import { IHttpService, IHttpRequest } from '@/app-modules/http';
import { injectable, inject } from 'inversify';
import { SERVICE_IDENTIFIERS } from '@/app-modules/_ioc/service-identifiers';
import { IPersistedStore } from '@/app-modules/store/persisted-store';
import { TogglesStore } from '@/app-modules/store/modules/toggles';
import { AxiosResponse } from 'axios';

interface ITogglesService {
    populateToggleStore(useNewToggleEndPoint: boolean): void;
    populateTogglesPreLogin(): void;
    isLive(toggle: string): Promise<boolean>;
    refreshToggleCache(useNewToggleEndPoint: boolean): void;
}

@injectable()
class TogglesService implements ITogglesService {
    constructor(@inject(SERVICE_IDENTIFIERS.IHttpService) private readonly httpService: IHttpService,
    @inject(SERVICE_IDENTIFIERS.IPersistedStore) private readonly persistedStore: IPersistedStore){

    }

    public async populateToggleStore(useNewToggleEndPoint: boolean){
        const request: IHttpRequest = {
            Url: '/toggles',
        };
        const response = await this.httpService.get(request, useNewToggleEndPoint);
        console.log(response);
        this.saveStoreCacheFromHttpResponse(response, useNewToggleEndPoint);
    }

    public async populateTogglesPreLogin(){
        const request: IHttpRequest = {
            Url: '/toggles/pre-login',
        };
        // pass in the UK as override country as we are getting system toggles only pre-login
        const response = await this.httpService.get(request, false, 'uk');
        this.saveStoreCacheFromHttpResponse(response, false);
    }

    public async isLive(toggle: string): Promise<boolean>{

        if (this.isToggleStoreEmpty()){
            // repopulate toggle store if it somehow becomes empty
            // we might come in here if the new endpoint has failed so load from old endpoint
            await this.populateToggleStore(false);
        }

        return this.queryToggleStore(toggle);

    }

    public async refreshToggleCache(useNewToggleEndPoint: boolean) {
        const request: IHttpRequest = {
            Url: '/toggles/clear',
          };
        await this.httpService.post(request, useNewToggleEndPoint);
        await this.populateToggleStore(useNewToggleEndPoint);
    }

    private isToggleStoreEmpty(): boolean{
        const toggleStore = this.persistedStore.Get(TogglesStore);
        return Object.keys(toggleStore.toggles).length === 0 && toggleStore.toggles.constructor === Object;
    }

    private queryToggleStore(toggle: string): boolean{
        const toggleStore = this.persistedStore.Get(TogglesStore);
        return toggleStore.toggles[toggle] === true;
    }

    private saveStoreCacheFromHttpResponse(response: AxiosResponse<any>, useNewToggleEndPoint: boolean){
        const toggleStore = this.persistedStore.Get(TogglesStore);
        if (useNewToggleEndPoint){
            toggleStore.toggles = response.data;
        }
        else{
            toggleStore.toggles = response.data.Data;
        }
        this.persistedStore.Save(toggleStore);
    }
}

export { TogglesService, ITogglesService };



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/app-modules/config/toggles-service.ts